import styled from 'styled-components';

interface IContainer {
  active?: boolean;
  haveBottomMargin?: boolean;
  removeMaxWidth?: boolean;
  color?: string;
}

export const Container = styled.div<IContainer>`
  background-color: ${({ active, color }) => (active ? '#1371FE' : color)};
  border-radius: 12px;
  padding: 0 10px;
  cursor: pointer;
  user-select: none;
  height: 24px;
  overflow: hidden;
  display: table;
  align-items: center;
  width: fit-content;
  margin-bottom: ${({ haveBottomMargin }) => (haveBottomMargin ? '10px' : '0')};

  & + & {
    margin-left: 8px;
  }
`;

export const Label = styled.div<IContainer>`
  color: #474d66;
  color: ${({ color, active }) => {
    if (color === '#E7E4F9') return '#524988';
    if (color === '#DCF2EA') return '#317159';
    if (color === '#FFEFD2') return '#66460D';
    if (color === '#D3F5F7') return '#0F5156';
    if (color === '#F8E3DA') return '#85462B';
    if (color === '#FBDDF3') return '#8E3374';
    if (color === '#F9DADA') return '#7D2828';
    if (color === '#E6EDFF') return '#1F3D99';
    if (active) return '#fff';
    return '#474d66';
  }};
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
`;
export const DarkLabel = styled(Label)`
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  margin-right: 8px;
`;
export const TagBody = styled.div<IContainer>`
  display: flex;
  flex-direction: row;
  white-space: nowrap;
  max-width: ${({ removeMaxWidth }) => (removeMaxWidth ? 'unset' : '180px')};
  position: relative;
  overflow: hidden;
`;
